import {Hero} from '@primer/react-brand'

import {getImageSources, MAX_CONTENT_WIDTH} from '@github-ui/swp-core/lib/utils/images'

import {AssetTypeEnum} from '../../types'
import {AssetVideo} from '../Video'
import type {FlexSuiteStackedHeroProps} from './types'
import {HeroContent} from './HeroContent'

/**
 * Stacked hero: center-aligned with a block-end image or video
 */
export function FlexSuiteHeroStacked({fields}: {fields: FlexSuiteStackedHeroProps}) {
  const {heroAsset} = fields
  const {assetType, optionImage, optionVideo, optionPoster, autoplay, videoSource} = heroAsset?.fields ?? {}

  return (
    <HeroContent {...fields} data-testid="hero-stacked">
      {assetType === AssetTypeEnum.enum.Image && optionImage && (
        <Hero.Image
          as="picture"
          src={`${optionImage.fields.file.url}?fm=webp`}
          sources={getImageSources(optionImage.fields.file.url, {
            maxWidth: MAX_CONTENT_WIDTH,
            disableDprScaling: true,
          })}
          alt={optionImage.fields.description ?? ''}
          enableBorder={false}
        />
      )}
      {assetType !== AssetTypeEnum.enum.Image && (
        <AssetVideo
          assetType={assetType}
          optionVideo={optionVideo}
          optionPoster={optionPoster}
          autoplay={autoplay}
          videoSource={videoSource}
        />
      )}
    </HeroContent>
  )
}
